import { SkeletonLine } from '@spo/storybook';
import { VpIcon } from '@vtmn-play/react';
import { clsx } from 'clsx';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './smInfoDisplay.scss';

type SmInfoDisplayProps = {
  children: string | number | React.JSX.Element | null | undefined;
  label: string;
  isLoading: boolean;
  copyTool?: boolean;
};

export const SmInfoDisplay = ({
  children,
  label,
  isLoading = true,
  copyTool = false,
}: SmInfoDisplayProps) => {
  const [displayTooltip, setDisplayTooltip] = useState(false);
  const { t } = useTranslation();

  const copyText = (textToCopy: string) => {
    navigator.clipboard.writeText(textToCopy);
  };

  const dataTestId = label
    .split(' ')
    .map((w, i) =>
      i === 0
        ? w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()
        : w.toLowerCase(),
    )
    .join('-');

  const renderChildren = () => {
    if (isLoading) {
      return <SkeletonLine small />;
    }
    return children != null ? children : t('sm-info.missing-information');
  };

  const clickOnCopyTool = (text: string) => {
    setDisplayTooltip(true);
    copyText(text);
    setTimeout(() => {
      setDisplayTooltip(false);
    }, 1000);
  };

  return (
    <div data-testid="sm-info-display" className="sm-info-display">
      <div
        data-testid={`sm-info-display-title_${dataTestId}`}
        className="sm-info-display-title"
      >
        {label}
      </div>
      <div
        data-testid="sm-info-display-children"
        className="sm-info-display-children"
      >
        {renderChildren()}
        {copyTool && (
          <div className="copy-tool-container">
            <div className={clsx('copy-tooltip', { open: displayTooltip })}>
              Copied
            </div>
            <VpIcon
              name="file-copy"
              data-testid="copy-tool-img"
              aria-label="copy-tool"
              size={20}
              onClick={() => children && clickOnCopyTool(children.toString())}
            />
          </div>
        )}
      </div>
    </div>
  );
};
